var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{domProps:{"innerHTML":_vm._s(_vm.messageToHTML(_vm.message))},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }